<template>
  <div>
      <div class="nav_company_name">
        <div style="width: 10%;display: flex;justify-content: end;">
          <i v-if="isCollapse" class="el-icon-s-unfold" style="color: #FFFFFF;font-size: 1.5rem" @click="menuZoom(false)"/>
          <i v-else class="el-icon-s-fold" style="color: #FFFFFF;font-size: 1.5rem" @click="menuZoom(true)"/>
        </div>
        <div class="top_company_title">
          <div class="small_logo_box">
             <img src="../../assets/image/index/companyLogo.png" style="width: 100%;height: auto"/>
          </div>
          <span>乐榜网络科技有限公司</span>
        </div>
      </div>
      <div v-if="isCollapse===false" class="menu_mask"></div>
      <div class="left_nav"  v-if="isCollapse===false" ref="treeWrap">
        <el-menu default-active="1" class="el-menu-vertical-demo" :default-active="activeIndex" @select="changeMenu" :collapse="isCollapse"  :collapse-transition="false">
          <el-menu-item index="1">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-office-building"></i>
            <span slot="title">智慧社区</span>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-s-data"></i>
            <span slot="title">BIG DATA</span>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-s-custom"></i>
            <span slot="title">关于我们</span>
          </el-menu-item>
        </el-menu>
      </div>
  </div>
</template>

<script>
export default {
  name: "leftHead",
  data(){
    return{
      isCollapse:true,
    }
  },
  props:{
    activeIndex:{
      type:String
    }
  },
  mounted() {
    let that=this;
    // 点击除常用语框外的地方关闭常用语框
    document.addEventListener('mouseup',(e) =>{
      let tree = this.$refs.treeWrap;
      if (tree) {
        if (!tree.contains(e.target)) {
          that.isCollapse =true;
        }
      }
    })
  },
  methods:{
    changeMenu(key){
      let that=this;
      let active=sessionStorage.getItem('active');
      if (active===key){
        return false;
      }else{
        sessionStorage.setItem('active',key);
        if(key==='1'){
          this.$router.push('/');
        }else if(key==='2'){
          this.$router.push('/smartCommunity');
        }else if(key==='3'){
          this.$router.push('/bigData');
        }if(key==='4'){
          this.$router.push('/companyIntroduce');
        }
      }
      that.isCollapse =true;
    },
    menuZoom(flag){
      let that=this;
      that.isCollapse=flag;
    }
  },
}
</script>

<style scoped>

.nav_company_name{
  width: 100%;
  height:4.5rem;
  z-index: 9;
  display: flex;
  align-items: center;
}
.top_company_title{
  width: 50%;
  height: 4.5rem;
  line-height: 4.5rem;
  text-align: center;
  color: white;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.small_logo_box{
  width: 30px;
  height: 2rem;
}
@media (max-width: 768px) {
  .nav_company_name{
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    background-color: #3271FF;
    position: fixed;
    top: 0;
    left: 0;
  }
  .menu_mask{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
  }
  .left_nav{
    width:214px;
    height: 100%;
    background-color: #FFFFFF;
    z-index:99;
    position: fixed;
    top: 0;
    left: 0;
  }
  .top_company_title{
    width: 80%;
    font-size: 1rem;
    text-align: center;
    color: white;
    height: 3rem;
    line-height: 3rem;
  }
  .small_logo_box{
    width: 30px;
    height: 2rem;
  }
}
/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .nav_company_name{
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    background-color: #3271FF;
    position: fixed;
    top: 0;
    left: 0;
  }
  .menu_mask{
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
  }
  .left_nav{
    width:214px;
    height: 100%;
    background-color: #FFFFFF;
    z-index:99;
    position: fixed;
    top: 0;
    left: 0;
  }
  .top_company_title{
    width: 80%;
    font-size: 1rem;
    text-align: center;
    color: white;
    height: 3rem;
    line-height: 3rem;
  }
  .small_logo_box{
    width: 30px;
    height: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/leftHead.vue